module.exports = __webpack_public_path__ + "img/ic_publicity_detail9_4.ea2d17c3.png";